import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { makeStyles } from '@material-ui/core/styles';
import { STATISTIC_BY_EXPIRE_DATE_COLORS } from 'appConstants';
import DateFormatter from './DateFormatter';
import TextCell from './TextCell';
import { getExpirationStatusLabel } from 'utils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  status: {
    color: ({ statusColor }) => statusColor,
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 1.3,
  },
  unavailable: {
    color: theme.palette.text.grey,
    fontSize: '0.75rem',
    lineHeight: 1.3,
  },
}));

const ExpirationStatusCell = ({ value, expirationType }) => {
  const statusColor =
    STATISTIC_BY_EXPIRE_DATE_COLORS[expirationType] || STATISTIC_BY_EXPIRE_DATE_COLORS.not_specified || 'inherit';
  const classes = useStyles({ statusColor });

  if (value === null || value === undefined) {
    return (
      <div className={classes.root}>
        <TextCell value={i18next.t('commonValues.notAvailable')} />
        <span className={classes.unavailable}>{i18next.t('legend.expiryStatusUnavailable')}</span>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <DateFormatter value={value} expirationType={expirationType} />
      <span className={classes.status}>{getExpirationStatusLabel(expirationType)}</span>
    </div>
  );
};

ExpirationStatusCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  expirationType: PropTypes.string,
};

ExpirationStatusCell.defaultProps = {
  value: null,
  expirationType: 'not_specified',
};

export default ExpirationStatusCell;
